export const filterConstants = {
    FILTER_APPLY: 'filter/apply',
    FILTER_RESET: 'filter/Reset',
    FILTER_NAME: 'Archicad-IssueFilter'
}